<template>
  <section class="view section-content h-100">
    <div class="header height" style="background-color: transparent"></div>
    <b-container class="static mb-4">
      <b-card no-body class="article-content overflow-hidden bg">
        <b-card-body>
      <b-row>
        <b-col lg="12">
            <span class="float-right"><a href="#" onClick="history.go(-1)"><i class="fal fa-arrow-left" style="font-size: 16px"/> {{$t('article.ln_13')}}</a></span>
        </b-col>
        <b-col lg="3">
          <b-img class="text-center" variant="default" :src="image" style="width: 100%;border-radius: 6px;" />
        </b-col>
        <b-col lg="9">
          <template v-if="loading">
            <h3 class="name"><b>{{ name }}</b></h3>
            <hr />
            <vue-markdown v-highlight :toc="true" class="markdown-body">{{ text }}</vue-markdown>
            <b-row no-gutters>
              <b-col lg="4"></b-col>
              <b-col lg="4">
                <div class="text-center mt-4">
                  <b-avatar variant="default" :src="author_image" :text="author | namegr" size="3rem"/>
                  <div class="mt-1">
                    <b-link :to="{ path: '/address/' + address}">{{ author === undefined ? address : author }}</b-link>
                  </div>
                </div>
              </b-col>
              <b-col lg="4"></b-col>
            </b-row>
            <span class="tleft float-left">
              <i class="fal fa-clock"/> <time-ago :refresh="1" long :locale="$i18n.locale" :datetime="timestamp * 1000" :tooltip="true"/>
            </span>
            <span class="tright float-right" v-if="owner">
              <b-link :to="{ path: '/articles/editor/' + id}"><i class="fal fa-pen-square text-secondary"/></b-link>
            </span>
          </template>
          <template v-else>
            <div class="text-center">
              <b-spinner class="text-center" style="width: 3rem; height: 3rem;"/>
            </div>
          </template>
        </b-col>
        <b-col lg="1"></b-col>
      </b-row>
        </b-card-body>
      </b-card>
      <message class="mt-4" v-if="post" scope-type="message-article" :scope-address="address" :scope-parent="Number(id)"/>
    </b-container>
  </section>
</template>

<script>

import Vue from 'vue';
import axios from 'axios';
import api from '../../libs/api';
import Message from '../../components/Message';
import VueMarkdown from 'vue-markdown';
import vueHljs from 'vue-hljs';
import TimeAgo from 'vue2-timeago';

import 'mavon-editor/dist/highlightjs/styles/github.min.css';
import 'mavon-editor/dist/markdown/github-markdown.min.css';

Vue.use(vueHljs)

export default {
  name: "article.view",
  components: {
    Message,
    VueMarkdown,
    TimeAgo
  },
  data() {
    return {
      id: this.$route.params.id,
      address: null,
      name: null,
      text: null,
      post: false,
      timestamp: null,
      author: null,
      author_image: null,
      image: null,
      owner: false,
      loading: false
    }
  },
  metaInfo() {
    return {
      title: this.$data.name,
      meta: [
        {vmid: 'description', property: 'description', content: this.name},
        {vmid: 'keywords', property: 'keywords', content: this.name},
        {vmid: 'og:title', property: 'og:title', content: this.name},
        {vmid: 'og:description', property: 'og:description', content: this.name}
      ]
    }
  },
  mounted() {
    this.getArticle(this.id);
  },
  methods: {
    getArticle(id) {
      this.loading = false;
      axios.post(api.article.view, {id: id}).then(async (response) => {

        await this.$storage("article", response.data.source[0].address, response.data.source[0].image).then((response) => {
          this.image = response;
        });

        await this.$storage("account", response.data.source[0].address, response.data.source[0].author_image).then((response) => {
          this.author_image = response;
        });

        this.name = response.data.source[0].name;
        this.text = response.data.source[0].text;
        this.address = response.data.source[0].address;
        this.post = response.data.source[0].post;
        this.author = response.data.source[0].author;
        this.timestamp = response.data.source[0].timestamp;
        this.$store.dispatch('getLocalStorageObject', 'account').then((account) => {
          if (account) {
            this.owner = account.address === this.address;
          }
        });
        this.loading = true;
      }).catch(() => {
        this.$router.push('/error/1');
      });
    }
  }
}
</script>

<style scoped>

.bg {
  background-color: #ffffff;
}

</style>